import React, { FC, useEffect, useState } from 'react'
import { Flex, Spin, Typography } from 'antd'
import AudioPlayer from 'react-h5-audio-player'
import { ModuleAudioExerciseDto } from '../../../../../shared/types/api'
import * as API_COURSES from '../../../../../shared/http/courses'


const { Text } = Typography

interface AudioPlayerProps {
    ex: ModuleAudioExerciseDto,
}

export const CourseAudioPlayer: FC<AudioPlayerProps> = ({ ex }) => {

    const [loading, setLoading] = useState<boolean>(false)
    const [url, setUrl] = useState<string | undefined>(undefined)


    useEffect(() => {
        setLoading(true)
        API_COURSES.playAudioExerciseV2(Number(ex.id))
            .then((blob) => {
                const url = URL.createObjectURL(blob)
                setUrl(url)
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setLoading(false)
            })
        return () => {
        }
    }, [])


    return (
        <>
            <Text>{ex.data.title}</Text>
            <Flex style={{ marginTop: 8, width: 300 }} align={'center'} gap={16}>
                {!loading && url ?
                    <AudioPlayer
                        showJumpControls={false}
                        layout='stacked-reverse'
                        src={url}
                        onPlay={e => console.log('onPlay')}
                        // other props here
                    /> : <Spin />
                }
            </Flex>
        </>
    )
}

